{
    "WHATSAPP_TEMPLATES": {
        "MODAL": {
            "TITLE": "Whatsapp Templates",
            "SUBTITLE": "Selecteer de whatsapp template die u wilt verzenden",
            "TEMPLATE_SELECTED_SUBTITLE": "Verwerk {templateName}"
        },
        "PICKER": {
            "SEARCH_PLACEHOLDER": "Templates zoeken",
            "NO_TEMPLATES_FOUND": "Geen templates gevonden voor",
            "LABELS": {
                "LANGUAGE": "Taal",
                "TEMPLATE_BODY": "Template bericht",
                "CATEGORY": "Categorie"
            }
        },
        "PARSER": {
            "VARIABLES_LABEL": "Variabelen",
            "VARIABLE_PLACEHOLDER": "Voer {variable} waarde in",
            "GO_BACK_LABEL": "Ga terug",
            "SEND_MESSAGE_LABEL": "Verstuur bericht",
            "FORM_ERROR_MESSAGE": "Vul alstublieft alle variabelen in voordat u deze verzendt"
        }
    }
}
